import React, { useCallback } from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AuthService from '../../services/authService';
import './Dashboard.css';
import styles from './SideBar.module.css';

const SideBar = ({ onLogout, loading, isOpen, onClose, unreadMessages = 0 }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const menuItems = [
        {
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <g>
                        <path d="M14.0755 0H17.4615C18.8637 0 20 1.14585 20 2.55996V5.97452C20 7.38864 18.8637 8.53449 17.4615 8.53449H14.0755C12.6732 8.53449 11.537 7.38864 11.537 5.97452V2.55996C11.537 1.14585 12.6732 0 14.0755 0" fill="currentColor" opacity="0.4" />
                        <path d="M5.9248 11.4658C7.3269 11.466 8.46285 12.6114 8.46289 14.0254V17.4404C8.46268 18.8533 7.3268 19.9998 5.9248 20H2.53809C1.13615 19.9998 0.000210316 18.8533 0 17.4404V14.0254C4.54606e-05 12.6115 1.13605 11.4661 2.53809 11.4658H5.9248ZM17.4619 11.4658C18.864 11.4661 20 12.6115 20 14.0254V17.4404C19.9998 18.8533 18.8639 19.9998 17.4619 20H14.0752C12.6732 19.9998 11.5373 18.8533 11.5371 17.4404V14.0254C11.5372 12.6114 12.6731 11.466 14.0752 11.4658H17.4619ZM5.9248 0C7.3268 0.000171152 8.46268 1.14575 8.46289 2.55957V5.97461C8.46285 7.38858 7.3269 8.53401 5.9248 8.53418H2.53809C1.13605 8.53394 4.52055e-05 7.38853 0 5.97461V2.55957C0.000210429 1.14579 1.13615 0.0002388 2.53809 0H5.9248Z" fill="currentColor" />
                    </g>
                </svg>
            ),
            label: t('nav.dashboard'),
            path: '/dashboard',
        },
        {
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M12 22C11.1818 22 10.4002 21.6698 8.83693 21.0095C4.94564 19.3657 3 18.5438 3 17.1613C3 16.7742 3 10.0645 3 7M12 22C12.8182 22 13.5998 21.6698 15.1631 21.0095C19.0544 19.3657 21 18.5438 21 17.1613V7M12 22V11.3548" stroke="#53545C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M8.32592 9.69138L5.40472 8.27785C3.80157 7.5021 3 7.11423 3 6.5C3 5.88577 3.80157 5.4979 5.40472 4.72215L8.32592 3.30862C10.1288 2.43621 11.0303 2 12 2C12.9697 2 13.8712 2.4362 15.6741 3.30862L18.5953 4.72215C20.1984 5.4979 21 5.88577 21 6.5C21 7.11423 20.1984 7.5021 18.5953 8.27785L15.6741 9.69138C13.8712 10.5638 12.9697 11 12 11C11.0303 11 10.1288 10.5638 8.32592 9.69138Z" stroke="#53545C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            ),
            label: t('nav.products'),
            path: '/dashboard/products',
        },
        {
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M8 16L16.7201 15.2733C19.4486 15.046 20.0611 14.45 20.3635 11.7289L21 6" stroke="#53545C" strokeWidth="1.5" strokeLinecap="round" />
                    <path d="M6 6H22" stroke="#53545C" strokeWidth="1.5" strokeLinecap="round" />
                    <path d="M6 22C7.10457 22 8 21.1046 8 20C8 18.8954 7.10457 18 6 18C4.89543 18 4 18.8954 4 20C4 21.1046 4.89543 22 6 22Z" stroke="#53545C" strokeWidth="1.5" />
                    <path d="M17 22C18.1046 22 19 21.1046 19 20C19 18.8954 18.1046 18 17 18C15.8954 18 15 18.8954 15 20C15 21.1046 15.8954 22 17 22Z" stroke="#53545C" strokeWidth="1.5" />
                </svg>
            ),
            label: t('nav.orders'),
            path: '/dashboard/orders',
        },
        {
            // A till receipt: sales rung up at the counter, as opposed to
            // orders placed through the app.
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M5 21V4.5C5 3.67157 5.67157 3 6.5 3H17.5C18.3284 3 19 3.67157 19 4.5V21L16.5 19.5L14 21L12 19.5L10 21L7.5 19.5L5 21Z" stroke="#53545C" strokeWidth="1.5" strokeLinejoin="round" />
                    <path d="M9 8H15" stroke="#53545C" strokeWidth="1.5" strokeLinecap="round" />
                    <path d="M9 12H15" stroke="#53545C" strokeWidth="1.5" strokeLinecap="round" />
                </svg>
            ),
            label: t('nav.sales'),
            path: '/dashboard/sales',
        },
        {
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M18.0714 18.0699C15.0152 21.1263 10.4898 21.7867 6.78642 20.074C6.23971 19.8539 5.79148 19.676 5.36537 19.676C4.17849 19.683 2.70117 20.8339 1.93336 20.067C1.16555 19.2991 2.31726 17.8206 2.31726 16.6266C2.31726 16.2004 2.14642 15.7602 1.92632 15.2124C0.212831 11.5096 0.874109 6.98269 3.93026 3.92721C7.8316 0.0244319 14.17 0.0244322 18.0714 3.9262C21.9797 7.83501 21.9727 14.1681 18.0714 18.0699Z" stroke="#53545C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M14.9394 11.413H14.9484" stroke="#53545C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M10.9304 11.413H10.9394" stroke="#53545C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M6.9214 11.413H6.9304" stroke="#53545C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            ),
            label: t('nav.messages'),
            path: '/dashboard/messages',
            badge: unreadMessages > 0 ? String(unreadMessages) : null
        },
        {
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M7.842 12.957C11.531 12.957 14.684 13.516 14.684 15.749C14.684 17.982 11.552 18.557 7.842 18.557C4.152 18.557 1 18.003 1 15.769C1 13.535 4.131 12.957 7.842 12.957Z" stroke="#53545C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M7.842 9.77C5.42 9.77 3.456 7.807 3.456 5.385C3.456 2.963 5.42 1 7.842 1C10.263 1 12.227 2.963 12.227 5.385C12.236 7.798 10.286 9.761 7.873 9.77H7.842Z" stroke="#53545C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            ),
            label: t('nav.customers'),
            path: '/dashboard/customers'
        },
        {
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M4 9V20" stroke="#53545C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M8 4V20" stroke="#53545C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M12 11V20" stroke="#53545C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M16 7V20" stroke="#53545C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M20 14V20" stroke="#53545C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            ),
            label: t('nav.analytics'),
            path: '/dashboard/analytics'
        },
        {
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect x="2" y="6" width="20" height="14" rx="2" stroke="#53545C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M2 10H22" stroke="#53545C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M6 15H10" stroke="#53545C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            ),
            label: t('nav.payouts'),
            path: '/dashboard/payouts'
        },
        {
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M12 2L14.9 8.6L22 9.3L16.7 14.1L18.2 21L12 17.3L5.8 21L7.3 14.1L2 9.3L9.1 8.6L12 2Z" stroke="#53545C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            ),
            label: t('nav.reviews'),
            path: '/dashboard/reviews'
        },
        {
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M18.5281 6.34554L17.9057 5.26545C17.3791 4.35153 16.2121 4.03624 15.297 4.56064V4.56064C14.8613 4.81727 14.3415 4.89008 13.8521 4.76301C13.3628 4.63594 12.944 4.31944 12.6883 3.8833C12.5237 3.60607 12.4353 3.29032 12.432 2.96796V2.96796C12.4468 2.45115 12.2518 1.95033 11.8915 1.57959C11.5311 1.20886 11.036 0.999787 10.5189 1H9.26494C8.7584 0.999994 8.27275 1.20184 7.91544 1.56087C7.55812 1.9199 7.35861 2.40652 7.36105 2.91304V2.91304C7.34603 3.95885 6.49392 4.79873 5.448 4.79863C5.12565 4.79528 4.80989 4.70687 4.53267 4.54233V4.54233C3.6175 4.01794 2.45055 4.33322 1.92397 5.24714L1.25578 6.34554C0.729846 7.25832 1.04084 8.42453 1.95143 8.95423V8.95423C2.54334 9.29596 2.90797 9.92751 2.90797 10.611C2.90797 11.2945 2.54334 11.926 1.95143 12.2677V12.2677C1.04199 12.7939 0.730663 13.9573 1.25578 14.8673V14.8673L1.88736 15.9565C2.13408 16.4017 2.54804 16.7302 3.03763 16.8694C3.52722 17.0085 4.05208 16.9468 4.49606 16.6979V16.6979C4.93252 16.4433 5.45262 16.3735 5.94078 16.5041C6.42893 16.6348 6.84467 16.955 7.0956 17.3936C7.26013 17.6708 7.34854 17.9866 7.35189 18.3089V18.3089C7.35189 19.3655 8.20839 20.222 9.26494 20.222H10.5189C11.5719 20.222 12.4269 19.371 12.432 18.3181V18.3181C12.4295 17.81 12.6303 17.3219 12.9896 16.9626C13.3489 16.6034 13.8369 16.4026 14.345 16.405C14.6666 16.4136 14.9811 16.5017 15.2604 16.6613V16.6613C16.1731 17.1873 17.3394 16.8763 17.8691 15.9657V15.9657L18.5281 14.8673C18.7832 14.4294 18.8532 13.9079 18.7226 13.4183C18.5921 12.9287 18.2717 12.5113 17.8324 12.2586V12.2586C17.3932 12.0059 17.0728 11.5885 16.9422 11.0989C16.8117 10.6092 16.8817 10.0877 17.1368 9.64989C17.3027 9.36026 17.5428 9.12012 17.8324 8.95423V8.95423C18.7376 8.42482 19.0478 7.26542 18.5281 6.35469V6.35469V6.34554Z" stroke="#53545C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <circle cx="9.89651" cy="10.611" r="2.63616" stroke="#53545C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            ),
            label: t('nav.settings'),
            path: '/dashboard/settings',
        },
        {
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" stroke="#53545C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            ),
            label: t('nav.smsSettings'),
            path: '/dashboard/sms',
        },
        {
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M12 5V19M5 12H19" stroke="#53545C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            ),
            label: t('nav.addStore'),
            path: '/dashboard/stores/add',
        }
    ];

    const handleLogout = useCallback(async () => {
        if (onLogout) {
            // Use the logout handler passed from parent (DashboardLayout)
            await onLogout();
        } else {
            // Fallback logout implementation
            try {
                console.log('Initiating logout...');
                
                // Verify session before logout (optional)
                try {
                    await AuthService.verifySession();
                } catch (sessionError) {
                    console.warn('Session already invalid, proceeding with logout');
                }
                
                // Delete all sessions
                await AuthService.deleteAllSessions();
                console.log('Session terminated successfully');
                
                // Clear all stored authentication data
                localStorage.removeItem('rememberMe');
                localStorage.removeItem('userEmail');
                localStorage.removeItem('userId');
                localStorage.removeItem('storeId');
                localStorage.removeItem('storeRegistrationDetails');
                localStorage.removeItem('storeLocationDetails');
                localStorage.removeItem('storePaymentDetails');
                localStorage.removeItem('locationType');
                
                // Navigate to login page
                navigate('/login', { replace: true });
            } catch (error) {
                console.error('Error during logout:', error);
                
                // Even if logout fails, clear local storage and navigate for security
                localStorage.clear();
                
                // Force navigation to login
                navigate('/login', { replace: true });
            }
        }
    }, [onLogout, navigate]);

    return (
        <div className={`${styles.sidebar} ${isOpen ? styles.open : ''}`}>
            <div className={styles.logoContainer}>
                <img src="/images/logo.png" alt="Beetle Logo" className={styles.logoImage} />
                <span className={styles.seller}>Seller</span>
            </div>
            <div className={styles.menuitems}>
                {menuItems.map((item, index) => (
                        <NavLink
                            key={index}
                            to={item.path}
                            end={item.path === '/dashboard'}
                            onClick={() => { if (onClose) onClose(); }}
                        >
                            {({ isActive: navIsActive }) => (
                                <div className={`${styles.menuItem} ${navIsActive ? styles.active : ''}`}>
                                    <span className={styles.iconlybulkcategory} style={{ color: navIsActive ? '#FFFFFF' : '#53545C' }}>
                                        {item.icon}
                                    </span>
                                    <span
                                        className={styles.dashboard}
                                        style={{
                                            color: navIsActive ? '#FFFFFF' : '#53545C',
                                            fontFamily: 'Inter, sans-serif',
                                            fontSize: '14px',
                                            fontWeight: '400',
                                            lineHeight: '20px'
                                        }}
                                    >
                                        {item.label}
                                    </span>
                                    {item.badge && (
                                        <span
                                            className={styles.wrapper}
                                            style={{
                                                backgroundColor: '#A6F4C5',
                                                color: '#1C1D22',
                                                borderRadius: '500px',
                                                padding: '4px 8px',
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                lineHeight: 'normal'
                                            }}
                                        >
                                            {item.badge}
                                        </span>
                                    )}
                                </div>
                            )}
                        </NavLink>
                ))}
            </div>
            <div className={styles.logout}>
                <div className={styles.logout03Parent}>
                    <button onClick={handleLogout} disabled={loading}>
                        <img className={styles.truckDeliveryIcon} alt="" src="/icons/logout-03.svg" />
                        <span className={styles.dashboard}>
                            {loading ? t('common.loggingOut') : t('common.logout')}
                        </span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SideBar; 